import { isEmpty } from "lodash"
import React, { useState } from "react"
import { Col, Form, Input, Label, Row } from "reactstrap"
import Select from "react-select"
import { customStylesSelect } from "common/data/settings"
const searchForm = props => {
  const {
    handleSubmit,
    handleAddnewUser,
    columns,
    getUserListAPI,
    setshowHide,
    tableFilter,
    columnaccessor,
    setsearchKey,
    searchKey,
    hideAddUserbutton,
  } = props

  const handleChanges = event => {
    setshowHide(event.target.value)
  }

  return (
    <Form onSubmit={handleSubmit}>
      <Row className="mb-2 mobile_responsive_user">
        <Col md={3} className=" justify-content-start">
          <Select
            className="mb-2"
            value={columnaccessor}
            onChange={value => {
              tableFilter(null)
              setTimeout(() => {
                tableFilter(value)
              }, 100)
              setsearchKey("")
            }}
            options={columns}
            classNamePrefix="select2-selection"
            styles={customStylesSelect}
          />
        </Col>
        <Col md={3} className=" justify-content-start">
          {columnaccessor?.dataType === "string" && (
            <div className="d-flex">
              <Input
                type="text"
                className="mb-2 padding-tests"
                placeholder={`Search by ${columnaccessor?.Header}`}
                value={searchKey || ""}
                onChange={e => {
                  if (e.target.value === "") {
                    getUserListAPI("initialcall")
                  }
                  setsearchKey(e.target.value)
                }}
              />
              {columnaccessor?.dataType === "string" && (
                <button
                  type="button"
                  className="close"
                  aria-label="Close"
                  style={{ marginTop: "-3px", marginRight: "10px" }}
                  onClick={() =>
                    getUserListAPI("initialcall") || setsearchKey("")
                  }
                >
                  <span aria-hidden="true">&times;</span>
                </button>
              )}
            </div>
          )}
          {columnaccessor?.dataType === "boolean" && (
            <Row>
              <Col className="d-flex">
                <div className="text-sm-end">
                  <div className="form-check me-3 mt-2">
                    <Input
                      name="choose"
                      type="radio"
                      className="form-check-input"
                      id="yes"
                      value="yes"
                      onChange={handleChanges}
                    />
                    <Label className="form-check-label" htmlFor="yes">
                      Yes
                    </Label>
                  </div>
                </div>
                <div className="text-sm-end">
                  <div className="form-check me-3 mt-2">
                    <Input
                      name="choose"
                      type="radio"
                      value="no"
                      className="form-check-input"
                      onChange={handleChanges}
                      id="no"
                    />

                    <Label className="form-check-label" htmlFor="no">
                      No
                    </Label>
                  </div>
                </div>
              </Col>
            </Row>
          )}
        </Col>
        {columnaccessor?.dataType === "string" ? (
          <Col className=" justify-content-start d-flex">
            <div className="text-sm-end">
              <button
                type="submit"
                className="btn btn-primary save-customer"
                onClick={handleSubmit}
              >
                Search
              </button>
            </div>
          </Col>
        ) : (
          ""
        )}
      
      </Row>
    </Form>
   
    
  )
}
export default searchForm
